import React from 'react';
import PropTypes from 'prop-types';
import Label from '../Label';
import classnames from 'classnames';

const baseInputClasses =
  'shadow transition duration-300 appearance-none border border-inputfield-main focus:border-inputfield-focus focus:outline-none disabled:border-inputfield-disabled rounded w-full py-2 px-3 text-sm text-white placeholder-inputfield-placeholder leading-tight';

const containerClass = "flex items-center border border-gray-300 rounded-md p-2 w-full border-inputfield-main bg-black";
const iconClass = "w-fit h-4 mr-2";
const inputClass = "flex-1 text-gray-500 placeholder-gray-400 bg-transparent focus:outline-none";

const transparentClasses = {
  true: 'bg-transparent',
  false: 'bg-black',
};

const smallInputClasses = {
  true: 'input-small',
  false: '',
};

const Input2 = ({
  id,
  label,
  containerClassName = '',
  labelClassName = '',
  className = '',
  transparent = false,
  smallInput = false,
  type = 'text',
  value,
  onChange,
  onFocus,
  autoFocus,
  onKeyPress,
  onKeyDown,
  readOnly,
  disabled,
  labelChildren,
  placeholder,
  icon,
  ...otherProps
}) => {
  // flex flex-1 flex-col
  return (
    // <div className={classnames('relative w-full', containerClassName)}>
    <div className={classnames(containerClass)}>
      <img src={icon} alt="Email Icon" className={iconClass}></img>
      {/* <Label
        className={labelClassName}
        text={label}
        for={id}
      ></Label> */}
      <span className={"text-base pr-1 color-white font-bold"}>{label + " "}:</span>
      <input
        id={id}
        data-cy={`input-${id}`}
        className={classnames(
          label && '',
          className,
          "text-base",
          // baseInputClasses,
          // transparentClasses[transparent],
          smallInputClasses[smallInput],
          { 'cursor-not-allowed': disabled }
        )}
        disabled={disabled}
        readOnly={readOnly}
        autoFocus={autoFocus}
        type={type}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onKeyPress={onKeyPress}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        {...otherProps}
      />
    </div>
  );
};

Input2.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  className: PropTypes.string,
  transparent: PropTypes.bool,
  smallInput: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  autoFocus: PropTypes.bool,
  readOnly: PropTypes.bool,
  onKeyPress: PropTypes.func,
  onKeyDown: PropTypes.func,
  disabled: PropTypes.bool,
  labelChildren: PropTypes.node,
  placeholder: PropTypes.string,
};

export default Input2;
